import { useQuery } from '@tanstack/react-query';
import { epochsApi, type Epoch } from '../api';

/**
 * Aktivní epocha. Skoro všechno se jí musí omezovat — členy a skupiny filtruje
 * server sám, ale hry a statistiky ne, a bez ní by se epochy míchaly dohromady.
 */
export function useActiveEpoch(): {
  epoch: Epoch | null;
  isLoading: boolean;
  epochs: Epoch[];
} {
  const q = useQuery({ queryKey: ['epochs'], queryFn: epochsApi.getAll });
  return {
    epoch: q.data?.find((e) => e.is_active === 1) ?? null,
    isLoading: q.isLoading,
    epochs: q.data ?? [],
  };
}
